const CONSENT_DOMAIN = 'consent'

const CONSENT_STATE = {
  hasShownBanner: false,
  analytics: null, // null = not set, true = granted, false = denied
  marketing: null,
  preferences: null,
  isEeaRegion: null, // null = not determined, true = EEA/UK/CH, false = other
  regionDetected: false, // false = still using SSR default, true = client-side detection complete
  shouldUseApk: false // true = show APK modal, false = redirect to Play Store
}

const CONSENT_ACTION = {
  GRANT_ALL: 'CONSENT_GRANT_ALL',
  DENY_ALL: 'CONSENT_DENY_ALL',
  UPDATE_PREFERENCES: 'CONSENT_UPDATE_PREFERENCES',
  SET_REGION: 'CONSENT_SET_REGION',
  DISMISS_BANNER: 'CONSENT_DISMISS_BANNER'
}

const CONSENT_STORAGE_KEY = 'gymaholic_consent_preferences'

const EEA_COUNTRIES = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL',
  'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'CH', 'IS',
  'LI', 'NO'
]

export {
  CONSENT_ACTION,
  CONSENT_DOMAIN,
  CONSENT_STATE,
  CONSENT_STORAGE_KEY,
  EEA_COUNTRIES
}
